import {
  CLEAR_SCHEDULE_QUERY,
  STORE_PARAMS,
  STORE_SCHEDULE_QUERY,
} from '@/store/actions/schedule';

const getters = {
  isNeedRedirect: (state) => state.needRedirect,
  getScheduleRedirect: (state) => state,
};

const actions = {
  [CLEAR_SCHEDULE_QUERY]: ({ commit }) => commit(CLEAR_SCHEDULE_QUERY),
};

const mutations = {
  [STORE_SCHEDULE_QUERY]: (state, {
    name,
    params,
    query,
    needRedirect,
  }) => {
    state.name = name;
    state.params = params;
    state.query = query;
    state.needRedirect = needRedirect;
  },
  [STORE_PARAMS]: (state, params) => {
    state.params = params;
  },
  [CLEAR_SCHEDULE_QUERY]: (state) => {
    state.name = '';
    state.params = '';
    state.query = '';
    state.needRedirect = false;
  },
};

const state = {
  name: '',
  params: '',
  query: '',
  needRedirect: false,
};

export default () => ({
  getters,
  actions,
  mutations,
  state,
});
